export enum LocalStorageKey {
  RicercaAssistenze,
  RicercaRichieste,
  RicercaFondiStazione
}
